import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-36e376d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ant-row ss-margin-campos" }
const _hoisted_2 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_form_item, {
        label: "Campos do Relatório",
        class: "ss-margin-campos"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_select, {
            value: _ctx.computedValor,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.computedValor) = $event)),
            mode: "multiple",
            style: {"width":"100%"},
            placeholder: "Selecione os campos (ex: Vendedor, ValorTotal...)",
            options: _ctx.opcoesDisponiveis,
            "filter-option": _ctx.filtrarOpcoes,
            "max-tag-count": 10,
            "allow-clear": ""
          }, null, 8, ["value", "options", "filter-option"])
        ]),
        _: 1
      })
    ])
  ]))
}